import type { Rational } from './rational.js';
export interface EndingSpan{start:number;end:number;numbers:Set<number>}
export interface BackwardRepeat{measureIndex:number;targetIndex:number;times:number;afterJump?:boolean}
export interface SoundControl{measureIndex:number;edge:'start'|'end';attrs:Record<string,string>}
export interface PlaybackStep{sourceIndex:number;visit:number;repeatPass:number}
export interface PlaybackPlan{steps:PlaybackStep[];sourceMeasureNumbers:string[];endingSpans:EndingSpan[];warnings:string[]}
export interface NoteEvent{onset:Rational;duration:Rational;midi:number;velocity:number}
export interface TempoEvent{onset:Rational;bpm:Rational}
export interface UnrollReport{
 expandedMeasureCount:number;sourceOrderZeroBased:number[];sourceMeasureNumbers:string[];
 steps:Array<{sourceIndex:number;sourceMeasureNumber:string;sourceMeasureVisit:number;repeatPass:number}>;
 endingSpans:Array<{startIndex:number;endIndex:number;numbers:number[]}>;
 timingQuarters:Record<string,{sourceTraversal:string;unrolledOutput:string}>;
 tempoMap:Array<{quarter:string;bpm:string}>;
 playbackSeconds:number;
 warnings:string[];
}
export interface UnrollResult{musicxml:string;midi:Uint8Array;report:UnrollReport;plan:PlaybackPlan;input:{partCount:number;printedMeasureCount:number;filename?:string}}
